module.exports = __webpack_public_path__ + "assets/d411a73bdfcfe44435dc06fad9d0f10a.png";